/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import { format } from "date-fns";
import {
  showContaimerLoader,
  userID,
  showPriceValue,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "reports/";
var moduleName = "Payment Tracking Report";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      start_date: "",
      end_date: "",
      customer: "",
      customerList: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadCustomer();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        start_date: "",
        end_date: "",
        customer: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.customer?.value) {
      addParams += "&customer=" + this.state.customer.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }

    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + "reports/paymentTracking",
    };
    this.props.getListData(params);
  }
  loadCustomer() {
    var urlShringTxt =
      apiUrl + "customer/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customerList: res.data.result });
      }
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="payment-tracking" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <Select
                                value={this.state.customer}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "customer"
                                )}
                                placeholder="Select Customer"
                                isClearable={true}
                                options={this.state.customerList}
                              />
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.start_date}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "start_date"
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.end_date}
                                  minDate={
                                    this.state.start_date !== ""
                                      ? this.state.start_date
                                      : ""
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "end_date"
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <a
                                href={void 0}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={void 0}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th>Sale Nu.</th>
                                      <th>Invoice No.</th>
                                      <th>Sale Type</th>
                                      <th>Customer</th>
                                      <th>Contact</th>
                                      <th>Phone</th>
                                      <th>Sale Amount</th>
                                      <th>Balance Amount</th>
                                      <th>Recived Amount</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>
                                      <th>Sale Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{item.saleNumber}</td>
                                            <td>{item.saleInvoice}</td>
                                            <td>{item.saleType}</td>
                                            <td>{item.customerName}</td>
                                            <td>
                                              {item.customerContactPerson}
                                            </td>
                                            <td>{item.customerMobile}</td>
                                            <td>
                                              {showPriceValue(item.salePrice)}
                                            </td>
                                            <td>
                                              {showPriceValue(
                                                item.saleBalanceAmount
                                              )}
                                            </td>
                                            <td>
                                              {showPriceValue(
                                                item.salePrice -
                                                  item.saleBalanceAmount
                                              )}
                                            </td>
                                            <td>
                                              {item.saleCreatedON !== ""
                                                ? format(
                                                    new Date(item.startDate),
                                                    "dd-MM-yyyy"
                                                  )
                                                : ""}
                                            </td>
                                            <td>
                                              {item.saleCreatedON !== ""
                                                ? format(
                                                    new Date(item.endDate),
                                                    "dd-MM-yyyy"
                                                  )
                                                : ""}
                                            </td>
                                            <td>
                                              {item.saleCreatedON !== ""
                                                ? format(
                                                    new Date(
                                                      item.saleCreatedON
                                                    ),
                                                    "dd-MM-yyyy"
                                                  )
                                                : ""}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td className="text-center" colSpan={8}>
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>

                                <Pagenation
                                  params={{
                                    totalRecords: this.state.totalRecords,
                                    totalPage: this.state.totalPage,
                                    currentPage: this.state.currentPage,
                                  }}
                                  sateValChange={this.sateValChange}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
